import { render, staticRenderFns } from "./MemberAsset.vue?vue&type=template&id=aa7b0ba8&scoped=true&"
import script from "./MemberAsset.vue?vue&type=script&lang=js&"
export * from "./MemberAsset.vue?vue&type=script&lang=js&"
import style0 from "./MemberAsset.vue?vue&type=style&index=0&id=aa7b0ba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa7b0ba8",
  null
  
)

export default component.exports